module.exports = __webpack_public_path__ + "img/sticker-en50x50.17c15002.jpg";